import { cEl } from '../../../util';
import { checkAuth } from '../../../api/admin';
import { getHash, matchHash, navigateTo } from '../../AppHeader/Link';
import {
    PATH_ADMIN_HOME,
    PATH_ADMIN_LOGIN,
    PATH_ADMIN_MANAGEMENT,
    PATH_ADMIN_MANAGEMENT_CHANGE_PASSWORD,
    PATH_ADMIN_SUBMISSION_DETAIL,
    PATH_ADMIN_SUBMISSIONS,
} from '../../path';
import Login from './Login';
import Submissions from './Submissions';
import Submission from './Submission';
import Management from './Management';
import ChangePassword from './ChangePassword';
import { initializePersistentState } from './Submissions/Table';

function Admin() {
    const adminContainer = cEl('div');
    if (matchHash(PATH_ADMIN_LOGIN)) {
        adminContainer.append(Login());
    } else {
        checkAuth()
            .then(res => {
                if (window.location.hash === PATH_ADMIN_HOME) {
                    navigateTo(PATH_ADMIN_SUBMISSIONS);
                } else if (matchHash(PATH_ADMIN_SUBMISSIONS)) {
                    adminContainer.append(Submissions());
                } else if (matchHash(PATH_ADMIN_SUBMISSION_DETAIL)) {
                    adminContainer.append(Submission());
                } else {
                    initializePersistentState();
                    switch (getHash()) {
                        case PATH_ADMIN_MANAGEMENT:
                            adminContainer.append(Management());
                            break;
                        case PATH_ADMIN_MANAGEMENT_CHANGE_PASSWORD:
                            adminContainer.append(ChangePassword());
                            break;
                    }
                }
            })
            .catch(err => {
                if (err.response?.status !== 401) {
                    navigateTo(PATH_ADMIN_LOGIN);
                }
            });
    }

    return adminContainer;
}

export default Admin;
